import { SearchPage } from 'Components'
import TemplateMainContent from 'Stores/factoryreproductions/Templates/MainContent.rt'
import TemplatedealerSearchSearchPage from 'Stores/factoryreproductions/Templates/dealerSearch/SearchPage.rt'
import { SearchHeader } from 'Components'
import { SearchResult } from 'Components'
import TemplateFacetPanelContainer from 'Stores/factoryreproductions/Templates/FacetPanelContainer.rt'
import { FacetBar } from 'Components'
import { FacetPanel } from 'Components'
import { FacetTiles } from 'Components'
import TemplatefacetTileshierarchicalContainer from 'Stores/_default-store/Templates/facetTiles/hierarchicalContainer.rt'
import { VehicleWidget } from 'Components'
import { SearchBox } from 'Components'
import TemplateSearchBox from 'Stores/_default-store/Templates/SearchBox.rt'
import { SearchBoxDialogButton } from 'Components'
import TemplatesearchBoxdialogButtonMobile from 'Stores/_default-store/Templates/searchBox/dialogButtonMobile.rt'
import TemplatefitmentSearchcartVehicleWidget from 'Stores/factoryreproductions/Templates/fitmentSearch/cartVehicleWidget.rt'
import { SingleVehicleGarage } from 'Components'
import TemplatefitmentSearchsingleVehicleGarage from 'Stores/_default-store/Templates/fitmentSearch/singleVehicleGarage.rt'
import { VerifyFitment } from 'Components'
import TemplatefitmentSearchverifyFitment from 'Stores/factoryreproductions/Templates/fitmentSearch/verifyFitment.rt'
import { RelatedItems } from 'Components'
import TemplateproductrelatedItems from 'Stores/factoryreproductions/Templates/product/relatedItems.rt'
import TemplateproductwheelChart from 'Stores/factoryreproductions/Templates/product/wheelChart.rt'
import TemplateproductcartCrossSell from 'Stores/factoryreproductions/Templates/product/cartCrossSell.rt'
import { FitmentTable } from 'Components'
import TemplatefitmentSearchfitmentTable from 'Stores/_default-store/Templates/fitmentSearch/fitmentTable.rt'
import { AutoSyncVisualization } from 'Components'
import { FacetDialog } from 'Components'
import TemplateFacetDialog from 'Stores/_default-store/Templates/FacetDialog.rt'
import { SearchBoxDialog } from 'Components'
import TemplateSearchBoxDialog from 'Stores/_default-store/Templates/SearchBoxDialog.rt'
import { VehicleWidgetDialog } from 'Components'
import TemplatefitmentSearchdialog from 'Stores/factoryreproductions/Templates/fitmentSearch/dialog.rt'
import { AutoSyncVisualizationDialog } from 'Components'
import TemplatefitmentSearchautoSyncVisualizationDialog from 'Stores/_default-store/Templates/fitmentSearch/autoSyncVisualizationDialog.rt'

export const compMap = {
  SearchPage,
SearchHeader,
SearchResult,
FacetBar,
FacetPanel,
FacetTiles,
VehicleWidget,
SearchBox,
SearchBoxDialogButton,
SingleVehicleGarage,
VerifyFitment,
RelatedItems,
FitmentTable,
AutoSyncVisualization,
FacetDialog,
SearchBoxDialog,
VehicleWidgetDialog,
AutoSyncVisualizationDialog
}
export const tplMap = {
  'MainContent': TemplateMainContent,
'dealerSearch/SearchPage': TemplatedealerSearchSearchPage,
'FacetPanelContainer': TemplateFacetPanelContainer,
'facetTiles/hierarchicalContainer': TemplatefacetTileshierarchicalContainer,
'SearchBox': TemplateSearchBox,
'searchBox/dialogButtonMobile': TemplatesearchBoxdialogButtonMobile,
'fitmentSearch/cartVehicleWidget': TemplatefitmentSearchcartVehicleWidget,
'fitmentSearch/singleVehicleGarage': TemplatefitmentSearchsingleVehicleGarage,
'fitmentSearch/verifyFitment': TemplatefitmentSearchverifyFitment,
'product/relatedItems': TemplateproductrelatedItems,
'product/wheelChart': TemplateproductwheelChart,
'product/cartCrossSell': TemplateproductcartCrossSell,
'fitmentSearch/fitmentTable': TemplatefitmentSearchfitmentTable,
'FacetDialog': TemplateFacetDialog,
'SearchBoxDialog': TemplateSearchBoxDialog,
'fitmentSearch/dialog': TemplatefitmentSearchdialog,
'fitmentSearch/autoSyncVisualizationDialog': TemplatefitmentSearchautoSyncVisualizationDialog
};